import subjectListEn from "./locales/en.json";

export const SUBJECT_LIST_NS = "subjectList" as const;

export const SubjectListTranslations = {
  en: {
    [SUBJECT_LIST_NS]: {
      ...subjectListEn,
    },
  },
};
